export default __webpack_public_path__ + "static/media/IMG_2260.4eb23582.JPG";